import React, {Fragment, FunctionComponent, StrictMode, useEffect} from 'react'
import {Checkbox} from "@App/Components/common/Checkbox";
import {Organization, PremiumService, Service} from "@App/types";
import {useQuery} from "@apollo/client";
import {
    GET_ORGANIZATION_PREMIUM_SERVICES,
    OrganizationPremiumServicesQuery
} from "@App/graphql/queries/getOrganizationPremiumServices";
import {useTranslation} from "react-i18next";
import {OrganizationHasPremiumServicesVisibleInList, PremiumServiceIsReplacementOrPickup, PremiumServiceIsVisibleInList} from "@App/utils/conditionals/premiumServices";
import {OrganizationIsArvalOrMobilityConcept} from "@App/utils/conditionals/combinations";
import {usePremiumServiceUtils} from "@App/hooks/usePremiumServiceUtils";

type PremiumServiceFilterProps = {
    organization: Organization,
    service: Service,
    premiumServices?: PremiumService[]
    className?: string,
    onLoaded?: (hasItems: boolean) => void
}

type PremiumServiceFilterState = {
    premiumServices?: PremiumService[]
    typing: boolean
    inputTimeout: ReturnType<typeof setTimeout>
};

export const PremiumServiceFilterSingularInput: FunctionComponent<PremiumServiceFilterProps> = (props: PremiumServiceFilterProps, state: PremiumServiceFilterState) => {

    const {t} = useTranslation()

    const {
        togglePremiumService,
        toggleSingularPremiumService,
        toggled
    } = usePremiumServiceUtils()

    const existsInServices = (serviceArray: PremiumService[], premiumService: PremiumService) => {
        return serviceArray.some(p => p.id === premiumService.id)
    }

    const {loading, data, error} = useQuery<OrganizationPremiumServicesQuery>(GET_ORGANIZATION_PREMIUM_SERVICES, {
        variables: {
            organization: props.organization.id,
            services: [props.service.id],
        },
    })

    useEffect(() => {
            if (!loading && data) {
                props.onLoaded && props.onLoaded(OrganizationHasPremiumServicesVisibleInList(data.organization))
            }
        },
        [loading, data])


    if (loading) {
        return <div/>
    }

    const selectablePremiumServices = data.organization.premium_services.filter(PremiumServiceIsVisibleInList);

    const subsServices =  data.organization.premium_services.filter(premiumService => premiumService.service_type === 'sub-service');

    const exactlyOneSubserviceIsSelected = () => {
        return subsServices.filter((subService) => existsInServices(props.premiumServices, subService)).length === 1;
    }


    return (
        <StrictMode>
            {props.organization.settings.garage_list.filters.includes('services') && (
                <Fragment>
                    {subsServices?.length > 0 &&(
                        <div className="font-bold text-sm mb-3">{t('Gewählte Services')}</div>
                    )}
                    {subsServices?.map((premiumService) => (
                        <Fragment key={'fragment-' + premiumService.id}>
                            <Checkbox key={premiumService.id} status={toggled(premiumService)}
                                      title={premiumService.name + (premiumService.paid ? '*' : '')}
                                      disabled={(toggled(premiumService) && exactlyOneSubserviceIsSelected())}
                                      onChange={() =>toggleSingularPremiumService(premiumService)}
                            />
                        </Fragment>
                    ))}
                    {selectablePremiumServices?.length > 0 && (
                        <div className={`font-bold text-sm mb-3 ${subsServices?.length > 0 ? 'mt-8' : ''}`}>{t('premiumServices.additionalServices')}</div>
                    )}
                    {selectablePremiumServices?.map((premiumService) => (
                        <Fragment key={'fragment-' + premiumService.id}>
                            <Checkbox key={premiumService.id} status={toggled(premiumService)}
                                      title={premiumService.name + (premiumService.paid ? '*' : '')}
                                      onChange={() =>togglePremiumService(premiumService)}
                            />
                        </Fragment>
                    ))}

                    {selectablePremiumServices.length > 0 && (<p className={"text-xs mt-5"}>{t('garageList.filters.premiumServices.additional-cost-info')}</p>)}
                </Fragment>
            )}
        </StrictMode>
    )
}
